export default __webpack_public_path__ + "static/media/logo.9ec02249.svg";